import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

import { environment } from '../../environments/environment';
import { CartProvider } from '../core/cart-provider';
import { AuthService } from '../services/auth.service';

@Injectable()
export class QuickCartRouteGuard  {

    constructor(private cartProvider: CartProvider, private auth: AuthService, private router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const quickCartId = route.firstChild.params.id;
        if (!this.auth.isAuthenticated()) {
            this.auth.handleAuthenticationURLEntry(state.url);
            this.router.navigate(['/account/login']);
            return false;
        }

        // logic for quick cart feature
        if (!!quickCartId) {
            localStorage.setItem(environment.cartId, quickCartId);
            this.cartProvider.load();
        }

        return true;
    }
}
